import { TEACHER_ROUTE } from 'app/teacher/routing-constants/teacher-routing.constant';

export const LIVE_MODE_ROUTE = {
  name: 'livemode',
  route(classId: string): string[] {
    return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), this.name];
  },

  DEFAULT: ''
};
